export enum FEEDBACK_STEPS {
    IDLE = 'IDLE',
    FEEDBACK_FORM = 'FEEDBACK_FORM',
    SUCCESS = 'SUCCESS'
}
